import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) =>
  (<g fill={color}>
    <path d="M87 63.5H76v-11H66v11H55v10h11v11h10v-11h11v-10z" />
    <path d="M71 19.5H27a5 5 0 0 0-5 5v44a5 5 0 0 0 5 5h24v-14h11v-11h14v-24a5 5 0 0 0-5-5zM57 54H34v-5h23zm8-12H34v-5h31z" />
  </g>));
